<!--
 * @Author: wangxiaoheng
 * @Date: 2022-12-08 14:52:20
 * @LastEditors: wangxiaoheng
 * @LastEditTime: 2023-12-27 18:32:12
 * @FilePath: \saas_dev\src\App.vue
 * @Description: 
 * 
 * 
-->
<template>
  <div id="app">
    <!-- <div class="clear" @click="clear">清除缓存</div> -->
    <router-view />
  </div>
</template>
<script>
export default {
  created() {},
  watch: {
    //判断端口port 是否是抖音
    $route: {
      handler() {
        if (this.$route.query.port) {
          localStorage.setItem("port", this.$route.query.port);
        }
      },
      deep: true //深度监听
    }
  },
  methods: {
    clear() {
      window.sessionStorage.clear();
      window.localStorage.clear();
      alert("已清除");
      // window.location.reload();
    }
  }
};
</script>
<style lang="scss">
.clear {
  position: fixed;
  width: 60px;
  height: 24px;
  font-size: 12px;
  top: 0;
  z-index: 2000;
}

body,
html {
  margin: 0;
  padding: 0;
}

p {
  margin: 0;
}

li {
  list-style: none;
}

* {
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  // height: 100vh;
  max-width: 10rem;
  margin: 0 auto;
}

.overallLeft {
  /*居中起点对齐*/
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.overallCenter {
  /*居中*/
  display: flex;
  align-items: center;
  justify-content: center;
}

.overallbaseline {
  /*居中两端对齐，项目之间的间隔都是相等的 对齐*/
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.overallBetween {
  /*居中两端对齐，项目之间的间隔都是相等的*/
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.overallWrap-Left {
  /* 项目起点对齐，换行 */
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

//顶部对齐
.AlignTop {
  display: inline-block !important;
  vertical-align: top !important;
  text-align: left;
}
</style>
